var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"material-icons",class:{
    'material-icons-outlined': _vm.type == 'outlined',
  },style:({ fontSize: _vm.size })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }